import { CommonModule } from '@angular/common';
import { Component, Inject, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatStepperModule } from '@angular/material/stepper';
import { DataTiposGestionesBienesCulturales, ResponseTiposGestionesBienesCulturales } from '../../tabs/documentos-emitidos/models/gestiones-bienes-culturales';
import { BuscadorGestionesComponent } from 'app/modules/SharedEntitiesComponents/buscador-gestiones/buscador-gestiones.component';
import { DocumentosEmitidosService } from '../../tabs/documentos-emitidos/documentos-emitidos.service';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { BuscadorColeccionistaComponent } from 'app/modules/SharedEntitiesComponents/buscador-coleccionista/buscador-coleccionista.component';
import { HistorialPoseedorComponent } from 'app/modules/SharedEntitiesComponents/historial-poseedor/historial-poseedor.component';
import { FichaRegistro } from 'app/models/fichaRegistro.model';
import { RegistroTraspasoColeccionistaService } from './registro-traspaso-coleccionista.service';
import { TraspasoBienMueble } from '../models/traspasoBienMueble';
import { Coleccionista } from 'app/models/coleccionitas.model';
import { UtilsService } from 'app/modules/utils-service';
import { FormColeccionistaComponent } from 'app/modules/admin/coleccionistas/form-coleccionista/form-coleccionista.component';
import { ColeccionistasService } from 'app/modules/admin/coleccionistas/coleccionistas.service';
import { historialPoseedorBienCutural } from '../models/historial-traspaso-bien-cultural';
import { DetalleBienCulturalService } from '../../detalle-bien-cultural.service';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
    selector: 'registro-traspaso-coleccionista',
    templateUrl: 'registro-traspaso-coleccionista.component.html',
    imports:[
        CommonModule,
        MatButtonModule,
        MatStepperModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatIconModule,
        MatTabsModule,
        MatCheckboxModule,
        FormsModule,

        BuscadorGestionesComponent,
        BuscadorColeccionistaComponent,
        HistorialPoseedorComponent,
    ]
})

export class RegistroTraspasoColeccionistaComponent implements OnInit {
    listaGestiones: DataTiposGestionesBienesCulturales[] = [];
    gestionesSeleccionadasPadre: DataTiposGestionesBienesCulturales[] = [];
    historialPoseedorBienCutural: historialPoseedorBienCutural[]
    coleccionistaSeleccionado: Coleccionista
    traspasoBienMueble: TraspasoBienMueble= new TraspasoBienMueble
    cambioNoRegistro: boolean= false

    private _formBuilder = inject(FormBuilder);

    fichaRegistro:FichaRegistro
    

    constructor(
        public dialogRef: MatDialogRef<RegistroTraspasoColeccionistaComponent>,
        private documetosEmitidosService: DocumentosEmitidosService,
        private registroTrapasoColeccionista: RegistroTraspasoColeccionistaService,
        private _detalleBienesService: DetalleBienCulturalService,
        private utilsService: UtilsService,
        public dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: FichaRegistro
    ) { 
        this.getTiposGestionesBines()
        this.getHistorialTraspaso()
        this.fichaRegistro= this.data
    }
    
    firstFormGroup = this._formBuilder.group({
        firstCtrl: [''],
    });
    secondFormGroup = this._formBuilder.group({
        secondCtrl: ['', Validators.required],
    });

    ngOnInit() {}

    getTiposGestionesBines(){
        this.documetosEmitidosService.getGestionesByBienesCulturales()
            .then((response:ResponseTiposGestionesBienesCulturales)=>{
                this.listaGestiones= response.data
            })
    }

    recibirColeccionista(coleccionista: Coleccionista) {
        this.coleccionistaSeleccionado = coleccionista;
    }

    guardarTraspasoBienMueble(){
        this.traspasoBienMueble.coleccionistaUuid=this.coleccionistaSeleccionado?.coleccionistaUuid
        this.traspasoBienMueble.gestionesUuid= this.gestionesSeleccionadasPadre.map(g => g.gestionUuid)
        this.traspasoBienMueble.bienCulturalUuid=this.data.bienCulturalUuid
        this.traspasoBienMueble.cambioNoRegistro= this.cambioNoRegistro
        this.registroTrapasoColeccionista.postRegistroTraspaso(this.traspasoBienMueble)
        .then((response:any)=>{
            this.dialogRef.close(false)
            this._detalleBienesService.getFichaRegistro(this.fichaRegistro.bienCulturalUuid),
            this.utilsService.openSuccessSnakBar('Traspaso de bien mueble realizado con éxito.')
        })
    }

    agregarColeccionista(){
        const dialog = this.dialog.open(FormColeccionistaComponent, {
                    panelClass: ['w-full', 'md:w-5/12'],
                    height: 'calc(100vh - 4rem)',
                    disableClose:true,
                    data:this.fichaRegistro.seccion.descripcion
                })
    }

    getHistorialTraspaso(){
        this.registroTrapasoColeccionista.getHistorialTraspaso(this.data.bienCulturalUuid)
        .then((response:historialPoseedorBienCutural[])=>{
            this.historialPoseedorBienCutural= response
        })
    }
}